// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"home-solutions_productcontent__JLFdd"};